import React from 'react'
import NumberFormat from 'react-number-format'

export default function Phone({ children }) {
  const onlyDigits = children ? String(children).replace(/\D/g, '') : ''

  if (!onlyDigits) return null
  if (onlyDigits.length < 10) return <>{onlyDigits}</>

  const format = onlyDigits.length > 10 ? '(##)#####-####' : '(##)####-####'

  return (
    <NumberFormat
      value={onlyDigits}
      displayType={'text'}
      isNumericString={true}
      format={format}
    />
  )
}
